import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import Precios from '../reutilizables/precios/Precios'
import { buscarSimilaresPorPedido } from '../servicios/compraService'
import BordeDetalle from '../ui/BordeDetalle'
import LinkButton from '../ui/LinkButton'
import styles from './AnalisisCompra.module.css'

const AnalisisCompra = () => {
  const { idPedido } = useParams()
  const navigate = useNavigate()
  const [datos, setDatos] = useState([])
  const [cargando, setCargando] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    const cargar = async () => {
      try {
        const { data } = await buscarSimilaresPorPedido(idPedido)
        setDatos(data)
      } catch {
        setError(true)
      } finally {
        setCargando(false)
      }
    }
    cargar()
  }, [idPedido])

  const titulo = `Análisis de compra — Pedido #${idPedido}`
  const handleCerrar = () => navigate('/Pedidos')

  if (cargando) {
    return (
      <BordeDetalle titulo={titulo} onCerrarClick={handleCerrar}>
        <div className={styles.estado}>Cargando análisis...</div>
      </BordeDetalle>
    )
  }

  if (error) {
    return (
      <BordeDetalle titulo={titulo} onCerrarClick={handleCerrar}>
        <div className={styles.estado}>No se pudo cargar el análisis.</div>
      </BordeDetalle>
    )
  }

  const itemsConSimilares = datos.filter(
    (d) => Array.isArray(d.similares) && d.similares.length > 0
  )

  return (
    <BordeDetalle titulo={titulo} onCerrarClick={handleCerrar}>
      {itemsConSimilares.length === 0 ? (
        <div className={styles.estado}>Compraste la mejor opción!</div>
      ) : (
        itemsConSimilares.map((item) => (
          <div key={item.idPedidoItem} className={styles.seccion}>
            <h4 className={styles.subtitulo}>
              <i className="fa fa-search" aria-hidden="true" /> Oportunidades perdidas —{' '}
              {item.titulo ?? `Item #${item.idPedidoItem}`}
            </h4>
            <p className={styles.metaInfo}>- Productos similares:</p>
            <div className={styles.grilla}>
              {item.similares.map((pub) => (
                <div key={pub.idPublicacion}>
                  <LinkButton to={`/Publicacion/${pub.idPublicacion}`} className={styles.card}>
                    <div className={styles.cardImagen}>
                      {pub.pathImgPrincipal ? (
                        <img
                          src={pub.pathImgPrincipal}
                          alt={pub.titulo}
                          className={styles.imagen}
                        />
                      ) : (
                        <div className={styles.sinImagen}>
                          <i className="fa fa-image" aria-hidden="true" />
                        </div>
                      )}
                    </div>
                    <div className={styles.cardCuerpo}>
                      <p className={styles.cardTitulo}>{pub.titulo}</p>
                      <p className={styles.cardVendedor}>
                        <i className="fa fa-user" aria-hidden="true" /> {pub.razonSocial?.trim()}
                      </p>
                      <Precios
                        alicuota={pub.alicuota}
                        precio={pub.precioUnitario}
                        monedaSimbolo={pub.monedaSimbolo?.trim() ?? '$'}
                        className={styles.cardPrecio}
                        classNameValor={styles.cardPrecioValor}
                        classNameDescuento={styles.cardPrecioDescuento}
                        showSinIVA={true}
                      />
                      {pub.cantDisponible !== null && (
                        <p className={styles.cardStock}>Stock: {pub.cantDisponible}</p>
                      )}
                    </div>
                  </LinkButton>
                </div>
              ))}
            </div>
          </div>
        ))
      )}
    </BordeDetalle>
  )
}

export default AnalisisCompra
